import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
// Настройка react-modal для accessibility
Modal.setAppElement('#root');
const ConfirmModal = ({ isOpen, onClose, title, confirmText, cancelText, onConfirm, isLoading = false, }) => {
    const { t } = useTranslation();
    const handleConfirm = () => {
        onConfirm();
    };
    return (_jsxs(Modal, { isOpen: isOpen, onRequestClose: onClose, contentLabel: title, style: {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
            },
            content: {
                position: 'relative',
                background: 'white',
                borderRadius: '12px',
                padding: '24px',
                maxWidth: '500px',
                width: '90%',
                maxHeight: '90vh',
                border: 'none',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                outline: 'none',
            },
        }, children: [_jsxs("div", { style: { marginBottom: '20px' }, children: [_jsx("h3", { style: {
                            margin: '0 0 16px 0',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                        }, children: title }), _jsx("p", { style: {
                            margin: '0',
                            color: '#374151',
                            lineHeight: '1.5',
                        }, children: t('common.confirmAction', 'Вы уверены, что хотите выполнить это действие?') })] }), _jsxs("div", { style: {
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'flex-end',
                }, children: [_jsx("button", { onClick: onClose, disabled: isLoading, style: {
                            padding: '10px 16px',
                            borderRadius: '8px',
                            border: '1px solid #d1d5db',
                            background: 'white',
                            color: '#374151',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.6 : 1,
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'all 0.2s ease',
                        }, onMouseEnter: (e) => {
                            if (!isLoading) {
                                e.currentTarget.style.backgroundColor = '#f9fafb';
                                e.currentTarget.style.borderColor = '#9ca3af';
                            }
                        }, onMouseLeave: (e) => {
                            if (!isLoading) {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#d1d5db';
                            }
                        }, children: cancelText }), _jsx("button", { onClick: handleConfirm, disabled: isLoading, style: {
                            padding: '10px 16px',
                            borderRadius: '8px',
                            border: '1px solid #dc2626',
                            background: '#dc2626',
                            color: 'white',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.6 : 1,
                            fontSize: '14px',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.2s ease',
                        }, onMouseEnter: (e) => {
                            if (!isLoading) {
                                e.currentTarget.style.backgroundColor = '#b91c1c';
                                e.currentTarget.style.borderColor = '#b91c1c';
                            }
                        }, onMouseLeave: (e) => {
                            if (!isLoading) {
                                e.currentTarget.style.backgroundColor = '#dc2626';
                                e.currentTarget.style.borderColor = '#dc2626';
                            }
                        }, children: isLoading ? (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                                        width: '16px',
                                        height: '16px',
                                        border: '2px solid transparent',
                                        borderTop: '2px solid currentColor',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite',
                                    } }), t('common.loading', 'Загрузка...')] })) : (confirmText) })] }), _jsx("style", { children: `
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      ` })] }));
};
export default ConfirmModal;
